import Field from './Field';
import { FieldType } from 'larasnap/enums';

export default class extends Field {
    constructor(element, parent, props) {
        super(element, parent, props);

        const duration = props.fieldType === FieldType.DURATION_PICKER;

        this._input.clockpicker({
            placement: 'bottom',
            donetext: 'Set',
            leadingZeroHours: false,
            autoclose: true,
            duration,
        });
    }
}
